'use client';

import React from 'react';
import styled from 'styled-components';

export interface TabContentProps {
  children: React.ReactNode;
  active: boolean;
  className?: string;
}

const Content = styled.div`
  animation: fadeIn 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

/**
 * TabContent Component
 * 
 * A component for conditionally rendering tab content with fade-in animation.
 * Only renders children when active is true.
 * 
 * @component
 * @example
 * ```tsx
 * <TabContent active={activeTab === 'tab1'}>
 *   <div>Tab 1 Content</div>
 * </TabContent>
 * ```
 */
export const TabContent: React.FC<TabContentProps> = ({
  children,
  active,
  className,
}) => {
  if (!active) {
    return null;
  }

  return (
    <Content className={className}>
      {children}
    </Content>
  );
};

export default TabContent;

